import { get } from 'lodash';

import { API_NAME, FIELD_PATHS, REDUX_STORE } from '@funnels/constants';
import { EmploymentsActionTypes, EmploymentsReducerState, SharedActionTypes } from '@funnels/types';

const initialState: EmploymentsReducerState = {
  data: [],
  error: null,
  loading: 0,
};

export default function EmploymentsReducer(
  state: EmploymentsReducerState = initialState,
  action: EmploymentsActionTypes | SharedActionTypes
): EmploymentsReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: [],
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.CLEAR_EMPLOYMENTS_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.DELETE_EMPLOYMENTS:
      return {
        ...state,
        data: state.data.filter((Employment) => Employment.clientId !== action.clientId),
        loading: state.loading + 1,
      };
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.FETCH_EMPLOYMENTS:
      return {
        ...state,
        data: [],
        loading: state.loading + 1,
      };
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.FETCH_EMPLOYMENTS_SUCCESS:
      return {
        ...state,
        data: action.employments.map((employment) => ({
          ...employment,
          clientId: employment.id,
          companyClientId: employment.companyId,
        })),
        loading: state.loading - 1,
      };
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_EMPLOYMENTS:
      return {
        ...state,
        // partial replacement base on action applicant
        data: [
          ...state.data.filter(
            (employment) =>
              get({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_APPLICANT_ID(0)) !== action.applicantClientId
          ),
          ...action.employments.map((employment) => ({
            ...employment,
            id: state.data.find((e) => e.clientId === employment.clientId)?.id,
          })),
        ],
        loading: state.loading + 1,
      };
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_V2_EMPLOYMENTS:
      return {
        ...state,
        // partial replacement base on action applicant
        data: [
          ...state.data.filter(
            (employment) =>
              get({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_APPLICANT_ID(0)) !== action.applicantClientId
          ),
          ...action.employments,
        ],
        loading: state.loading + 1,
      };

    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_EMPLOYMENTS_SUCCESS:
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_V2_EMPLOYMENTS_SUCCESS:
      return {
        ...state,
        // partial replacement base on action applicant
        data: [
          ...state.data.filter(
            (employment) =>
              get({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_APPLICANT_ID(0)) !== action.applicantClientId
          ),
          ...action.employments,
        ],
        loading: state.loading - 1,
      };

    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPSERT_V2_EMPLOYMENTS:
      return {
        ...state,
        loading: state.loading + 1,
      };
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.DELETE_EMPLOYMENTS_SUCCESS:
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPSERT_V2_EMPLOYMENTS_SUCCESS:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.DELETE_EMPLOYMENTS_FAIL:
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.FETCH_EMPLOYMENTS_FAIL:
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_EMPLOYMENTS_FAIL:
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_V2_EMPLOYMENTS_FAIL:
    case REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPSERT_V2_EMPLOYMENTS_FAIL:
      return {
        ...state,
        error: {
          name: API_NAME.EMPLOYMENTS,
          message: action.message,
        },
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
